export default {"src":"https://www.bulletproof.co.uk/_next/static/media/powered-by-stripe.6209ccfc.svg","height":254,"width":923,"blurWidth":0,"blurHeight":0};